module.exports = __webpack_public_path__ + "static/img/family-0.fc727180.png";